import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { TriggerDetailsImpl } from "../model/impl/TriggerDetailsImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class TriggerDetailsImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: TriggerDetailsImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        TriggerDetailsImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.triggerRt != null) {
      this.baseEncoder.writeStartFid(961, streamout);
      this.baseEncoder.writeObject(
        false,
        TriggerDetailsImplEncoder.fidTypeMap.get(961),
        false,
        encodable.triggerRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(961, streamout);
    }
    /*Object encoding*/
    if (encodable.triggerSide != null) {
      this.baseEncoder.writeStartFid(962, streamout);
      this.baseEncoder.writeObject(
        false,
        TriggerDetailsImplEncoder.fidTypeMap.get(962),
        false,
        encodable.triggerSide,
        streamout,
      );
      this.baseEncoder.writeEndFid(962, streamout);
    }
    /*Object encoding*/
    if (encodable.triggerRateId != null) {
      this.baseEncoder.writeStartFid(963, streamout);
      this.baseEncoder.writeObject(
        false,
        TriggerDetailsImplEncoder.fidTypeMap.get(963),
        false,
        encodable.triggerRateId,
        streamout,
      );
      this.baseEncoder.writeEndFid(963, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,TriggerDetailsImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [100, "java.lang.String"],
    [961, "java.math.BigDecimal"],
    [962, "com.bcdfx.model.RateSideType"],
    [963, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: TriggerDetailsImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TriggerDetailsImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 961: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            TriggerDetailsImplEncoder.fidTypeMap.get(961),
            streamin,
          );
          encodable.triggerRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 962: {
          /*Object encoding*/
          let val: CubiqTS.RateSideType = this.baseEncoder.readObject(
            false,
            false,
            TriggerDetailsImplEncoder.fidTypeMap.get(962),
            streamin,
          );
          encodable.triggerSide = <CubiqTS.RateSideType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 963: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TriggerDetailsImplEncoder.fidTypeMap.get(963),
            streamin,
          );
          encodable.triggerRateId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,TriggerDetailsImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return TriggerDetailsImplEncoder.fidTypeMap.has(fid);
  }
}
